export default __webpack_public_path__ + "static/media/sd-event-4.41a9e2ca.png";